<!-- Test-only page: text here is deliberately left untranslated (out of scope per #4317). -->
<cs-header>
  <cs-header-title>Test Workout Solver</cs-header-title>
</cs-header>

<cs-content>
  <cs-card-list>
    <cs-card>
      <cs-card-content>
        <cs-button item-right (click)="handleRecheckAllTests()" [label]="'Test All' | untranslated"></cs-button>
        <cs-card-header>
          Inputs
        </cs-card-header>
        <cs-item-list>
          <cs-item>
            <cs-label> Test name </cs-label>
            <!-- [ariaLabel] names the picker: the Save button shares this row, so there is no
                 row text the select can take its name from -->
            <cs-select [ariaLabel]="'Test name' | untranslated"
              [(value)]="currentTest" (valueChange)="onSelectTestCaseAsync()">
              @for (test of allTests; track test) {
                <cs-select-option [value]="test" [label]="test.name | untranslated"></cs-select-option>
              }
            </cs-select>
            <cs-button item-right tertiary (click)="onRenameTestAsync()" [disabled]="!currentTest"
            [label]="'Rename' | untranslated"></cs-button>
            <cs-button item-right tertiary (click)="onAddTestAsync()" [label]="'Add' | untranslated"></cs-button>
            <cs-button item-right tertiary (click)="onDeleteTestAsync()" [disabled]="!currentTest || allTests.length < 2"
            [label]="'Delete' | untranslated"></cs-button>
          </cs-item>
          <cs-item>
            <cs-button item-right (click)="initiateSolving()" [label]="'Solve' | untranslated"></cs-button>
            <cs-button item-right tertiary (click)="onPrevNextTestAsync(-1)" [disabled]="!canPrevNextTest(-1)"
            [label]="'Previous' | untranslated"></cs-button>
            <cs-button item-right tertiary (click)="onPrevNextTestAsync(+1)" [disabled]="!canPrevNextTest(+1)"
            [label]="'Next' | untranslated"></cs-button>
            <cs-button item-right tertiary (click)="onSaveTestAsync()" [disabled]="!currentTest" [label]="'Save' | untranslated"></cs-button>
          </cs-item>
          <cs-item>
            <cs-label>Gender</cs-label>
            <cs-select [(value)]="params.gender">
              <cs-select-option [value]="Gender.female" [label]="'Female' | untranslated"></cs-select-option>
              <cs-select-option [value]="Gender.male" [label]="'Male' | untranslated"></cs-select-option>
            </cs-select>
          </cs-item>
          <cs-item>
            <cs-label>Energy balance factor</cs-label>
            <cs-input-measure type="relative_factor" [(canonValue)]="params.energyBalanceFactor"
            item-content></cs-input-measure>
          </cs-item>
          <cs-item>
            <cs-label>Stress level</cs-label>
            <cs-select [(value)]="params.stressLevel">
              <cs-select-option [value]="StressLevel.HighStress" [label]="'High stress' | untranslated"></cs-select-option>
              <cs-select-option [value]="StressLevel.Average" [label]="'Average stress' | untranslated"></cs-select-option>
              <cs-select-option [value]="StressLevel.MildStress" [label]="'Occasional/Mild stress' | untranslated"></cs-select-option>
            </cs-select>
          </cs-item>
          <cs-item>
            <cs-label>Sleep quality</cs-label>
            <cs-select [(value)]="params.sleepQuality">
              <cs-select-option [value]="SleepQuality.Poor" [label]="'Poor' | untranslated"></cs-select-option>
              <cs-select-option [value]="SleepQuality.Average" [label]="'Average' | untranslated"></cs-select-option>
              <cs-select-option [value]="SleepQuality.Great" [label]="'Great' | untranslated"></cs-select-option>
            </cs-select>
          </cs-item>
          <cs-item-list-header>Training Levels:</cs-item-list-header>
          @for (ex of ['$bench_press', '$chin_up', '$ohp', '$rdl', '$squat']; track ex) {
            <cs-item>
              <cs-label>&nbsp;&nbsp;{{ ex }}</cs-label>
              <cs-select [(value)]="params.trainingLevels[ex]">
                <cs-select-option [value]="TrainingLevel.Novice" [label]="'Novice' | untranslated"></cs-select-option>
                <cs-select-option [value]="TrainingLevel.Intermediate" [label]="'Intermediate' | untranslated"></cs-select-option>
                <cs-select-option [value]="TrainingLevel.Advanced" [label]="'Advanced' | untranslated"></cs-select-option>
                <cs-select-option [value]="null" [label]="'Undefined' | untranslated"></cs-select-option>
              </cs-select>
            </cs-item>
          }

          <cs-item>
            <cs-label>Muscle Growth Preference</cs-label>
            <cs-select [(value)]="params.muscleGrowth_main">
              <cs-select-option [value]="0" [label]="'Give me bare minimum' | untranslated"></cs-select-option>
              <cs-select-option [value]="1" [label]="'Maximize everything' | untranslated"></cs-select-option>
              <cs-select-option [value]="2" [label]="'Customize' | untranslated"></cs-select-option>
            </cs-select>
          </cs-item>
          @if (params.muscleGrowth_main == 2) {
            <cs-item-group>
              @for (m of ['chest', 'shoulders', 'traps', 'lats', 'biceps', 'triceps', 'quads', 'hams', 'glutes', 'calves', 'abs']; track m) {
                <cs-item>
                  <cs-label>&nbsp;&nbsp; {{ m }}</cs-label>
                  <cs-select [(value)]="params.muscleGrowth[m]">
                    <cs-select-option [value]="-1" [label]="'Shrink' | untranslated"></cs-select-option>
                    <cs-select-option [value]="0" [label]="'Maintain' | untranslated"></cs-select-option>
                    <cs-select-option [value]="1" [label]="'Maximize' | untranslated"></cs-select-option>
                  </cs-select>
                </cs-item>
              }
            </cs-item-group>
          }
          <cs-item-list-header>Training frequency</cs-item-list-header>
          <cs-grid item-content>
            <cs-grid-row class="training-frequency">
              <cs-grid-col>
                <cs-item>
                  <cs-label stacked>Monday</cs-label>
                  <cs-select [(value)]="params.trainingDays[0]">
                    <cs-select-option [value]="false" [label]="'No' | untranslated"></cs-select-option>
                    <cs-select-option [value]="true" [label]="'Yes' | untranslated"></cs-select-option>
                  </cs-select>
                </cs-item>
              </cs-grid-col>
              <cs-grid-col>
                <cs-item>
                  <cs-label stacked>Tuesday</cs-label>
                  <cs-select [(value)]="params.trainingDays[1]">
                    <cs-select-option [value]="false" [label]="'No' | untranslated"></cs-select-option>
                    <cs-select-option [value]="true" [label]="'Yes' | untranslated"></cs-select-option>
                  </cs-select>
                </cs-item>
              </cs-grid-col>
              <cs-grid-col>
                <cs-item>
                  <cs-label stacked>Wednesday</cs-label>
                  <cs-select [(value)]="params.trainingDays[2]">
                    <cs-select-option [value]="false" [label]="'No' | untranslated"></cs-select-option>
                    <cs-select-option [value]="true" [label]="'Yes' | untranslated"></cs-select-option>
                  </cs-select>
                </cs-item>
              </cs-grid-col>
              <cs-grid-col>
                <cs-item>
                  <cs-label stacked>Thursday</cs-label>
                  <cs-select [(value)]="params.trainingDays[3]">
                    <cs-select-option [value]="false" [label]="'No' | untranslated"></cs-select-option>
                    <cs-select-option [value]="true" [label]="'Yes' | untranslated"></cs-select-option>
                  </cs-select>
                </cs-item>
              </cs-grid-col>
              <cs-grid-col>
                <cs-item>
                  <cs-label stacked>Friday</cs-label>
                  <cs-select [(value)]="params.trainingDays[4]">
                    <cs-select-option [value]="false" [label]="'No' | untranslated"></cs-select-option>
                    <cs-select-option [value]="true" [label]="'Yes' | untranslated"></cs-select-option>
                  </cs-select>
                </cs-item>
              </cs-grid-col>
              <cs-grid-col>
                <cs-item>
                  <cs-label stacked>Saturday</cs-label>
                  <cs-select [(value)]="params.trainingDays[5]">
                    <cs-select-option [value]="false" [label]="'No' | untranslated"></cs-select-option>
                    <cs-select-option [value]="true" [label]="'Yes' | untranslated"></cs-select-option>
                  </cs-select>
                </cs-item>
              </cs-grid-col>
              <cs-grid-col>
                <cs-item>
                  <cs-label stacked>Sunday</cs-label>
                  <cs-select [(value)]="params.trainingDays[6]">
                    <cs-select-option [value]="false" [label]="'No' | untranslated"></cs-select-option>
                    <cs-select-option [value]="true" [label]="'Yes' | untranslated"></cs-select-option>
                  </cs-select>
                </cs-item>
              </cs-grid-col>
            </cs-grid-row>
          </cs-grid>
          <cs-item>
            <cs-button (click)="initiateSolving()" [label]="'Solve' | untranslated" fit-width></cs-button>
          </cs-item>
        </cs-item-list>
      </cs-card-content>
    </cs-card>
    <cs-card class="results">
      <cs-card-content>
        <cs-item-list>
          <cs-item-list-header>
            Results
            <cs-button tertiary (click)="showComparisons = !showComparisons" icon="split"></cs-button>
          </cs-item-list-header>
          <cs-item>
            <cs-button tertiary [disabled]="testPassed !== true && testPassed !== false"
              [ngClass]="{'danger' : testSolutionStatus === 'failed', 'warning' : testSolutionStatus === 'warning_passed'}"
              (click)="handleTestPassedInfoButtonPressed()"
              [label]="((testPassed === true && 'Passed') || (testPassed === false && 'Failed') || 'Unknown') | untranslated"
            [icon]="testPassed === true ? 'checkmark' : testPassed === false ? 'close' : 'help-circle'"></cs-button>
          </cs-item>
          <cs-item-list-header>
            Approved by:
          </cs-item-list-header>
        </cs-item-list>
        <cs-item>
          <cs-button (click)="onApprovalMenuAsync($event)" [disabled]="!resultDays || resultDays.length <= 0"
            [label]="(approvalText || 'not approved yet') | untranslated" fit-width>
            @if (approvalState === 'approved') {
              <cs-icon name="checkmark"></cs-icon>
            }
            @if (approvalState === 'failed') {
              <cs-icon name="close"></cs-icon>
            }
          </cs-button>
        </cs-item>
        @for (day of customDays; track day; let i = $index) {
          <div class="day">
            <cs-label>
              day {{ i + 1 }} ({{ day | dayExercises }} exercises, {{ day | daySets }} sets) (vs {{ resultDays[i] |
              dayExercises }}
              exercises, {{ resultDays[i] | daySets }} sets)
            </cs-label>
            @for (exercise of day; track exercise; let j = $index) {
              <div class="exercise">
                <cs-select [(value)]="exercise.subSlotId">
                  @for (id of exerciseIds; track id) {
                    <cs-select-option [value]="id" [label]="id | untranslated"></cs-select-option>
                  }
                </cs-select>
                <p class="times"></p>
                <cs-input-measure type="sets" [(canonValue)]="exercise.sets"></cs-input-measure>
                @if (showComparisons) {
                  <p class="vs-sets">
                    {{ originalSetsText(i, exercise.subSlotId) }} {{ exercise | evaluateExercise: { constants: constants }
                    }}
                  </p>
                }
              </div>
            }
            <div class="exercise">
              <cs-icon name="add" tappable (click)="day.push(createEmptyExercise())"></cs-icon>
            </div>
            @if (showComparisons) {
              <pre>
                {{
                i | evaluateDay: { constants: constants, customWorkout: customDays, originalWorkout: resultDays }
              }}</pre>
            }
          </div>
        }
        @if (showComparisons) {
          <pre>
            {{
            customDays | evaluateWorkout: { loopsPerWeek: loopsPerWeek, constants: constants, originalWorkout: resultDays }
          }}</pre>
        }
        <br />
        @if (solvedToApprovedDiff != null) {
          <div>
            @if (solvedToApprovedDiff.sameExercises) {
              <div style="background-color: lightblue">
                All exercises same, just different order!
              </div>
            }
            <div style="display: inline-block">
              Difference:&nbsp;
              <div style="display: inline-block; width: 10px; height: 10px; background-color: lightgreen"></div>
              &nbsp; Solved&emsp;
              <div style="display: inline-block; width: 10px; height: 10px; background-color: lightcoral"></div>
              &nbsp; Stored&emsp;
              <div style="display: inline-block; width: 10px; height: 10px; background-color: lightblue"></div>
              &nbsp; Same
            </div>
            @for (dayDiff of solvedToApprovedDiff.diff; track dayDiff; let iDay = $index) {
              <div class="dayDiff">
                Day {{iDay + 1}}
                @for (exerciseDiff of dayDiff; track exerciseDiff; let iExercise = $index) {
                  @if (exerciseDiff == -1 || exerciseDiff == 0 || exerciseDiff == 1) {
                    <div [ngClass]="{ 'exerciseDiffNormal': exerciseDiff == -1, 'exerciseDiffGreen': exerciseDiff != -1}"
                      >
                      @if (solvedToApprovedDiff.solved[iDay] && solvedToApprovedDiff.solved[iDay][iExercise]) {
                        {{iExercise +
                        1}}.&emsp;{{solvedToApprovedDiff.solved[iDay][iExercise].subSlotId}}&emsp;{{solvedToApprovedDiff.solved[iDay][iExercise].sets}}
                        sets
                      }
                    </div>
                  }
                  @if (exerciseDiff == 0 || exerciseDiff == 2) {
                    <div class="exerciseDiffRed">
                      @if (solvedToApprovedDiff.approved[iDay] && solvedToApprovedDiff.approved[iDay][iExercise]) {
                        {{iExercise +
                        1}}.&emsp;{{solvedToApprovedDiff.approved[iDay][iExercise].subSlotId}}&emsp;{{solvedToApprovedDiff.approved[iDay][iExercise].sets}}
                        sets
                      }
                    </div>
                  }
                }
              </div>
            }
          </div>
        }
      </cs-card-content>
    </cs-card>
    <cs-card>
      <cs-card-content>
        <h1>Debug</h1>
        <pre>{{ debug }}</pre>
      </cs-card-content>
    </cs-card>
    <cs-card>
      <cs-card-content>
        <div class="constants-foldout">
          <cs-button tertiary (click)="showConstants = !showConstants"
          [icon]="showConstants ? 'arrow-dropup' : 'arrow-dropdown'"></cs-button>
          <h1>constants</h1>
          @if (!showConstants) {
            <span>&nbsp;&nbsp;(not applied if folded!)</span>
          }
        </div>
        @if (showConstants) {
          <cs-textarea [placeholder]="'Paste values here, or run once to load the defaults.' | untranslated"
          [(value)]="constantsText"></cs-textarea>
        }
      </cs-card-content>
    </cs-card>
    <cs-card>
      <cs-card-content>
        <h1>Fitness plan</h1>
        <pre>{{ fitnessPlan }}</pre>
      </cs-card-content>
    </cs-card>
  </cs-card-list>
</cs-content>
